import React from "react";
import style from "./psButtons.scss"
import Icon from "sulu-admin-bundle/components/Icon";

const PsPcButtons = (
    {eventDetails, setEventDetails, confirmCallback, changeCallback, psEventActive, pcEventActive}) => {

    return (
    <>
        {eventDetails?.typeOfGoal && (
            <div className={style.buttonsWrapper}>
                <div
                    style={{
                        borderRadius: "50%",
                        backgroundColor: "transparent",
                        border: "1px solid black",
                        height: 35,
                        width: 35,
                        fontWeight: 700,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: 20,
                    }}
                >
                    <Icon name="fa-arrow-circle-right"/>
                </div>
                <button
                    style={{
                        backgroundColor: eventDetails?.typeOfGoal.backgroundColor,
                        color: eventDetails?.typeOfGoal.color
                    }}
                >{eventDetails?.typeOfGoal.name}</button>
                {eventDetails?.typeOfGoal && (
                    <button
                        style={{
                            border: "none",
                            backgroundColor: "transparent",
                            fontSize: "16px",
                            fontWeight: 500
                        }}
                        onClick={() => {
                            setEventDetails((data) => ({
                                ...data,
                                typeOfGoal: null,
                            }));
                            changeCallback && changeCallback();
                        }}
                    >
                        X
                        <span
                            style={{
                                border: "none",
                                backgroundColor: "transparent",
                                fontSize: "16px",
                                textDecoration: "underline",
                                marginLeft: 5,
                                fontWeight: 500
                            }}
                        >
                                Ändern
                        </span>
                    </button>
                )}
            </div>
        )}
        {!eventDetails?.typeOfGoal && (
            <div className={style.buttonsWrapper}>
                <div
                    style={{
                        borderRadius: "50%",
                        backgroundColor: "transparent",
                        border: "1px solid black",
                        height: 35,
                        width: 35,
                        fontWeight: 700,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: 20,
                    }}
                >
                    <Icon name="fa-arrow-circle-right" />
                </div>
                <button
                    style={{backgroundColor: eventDetails.sideSelected.teamColor}}
                    onClick={() => {
                        setEventDetails((data) => {
                            return {
                                ...data,
                                typeOfGoal: {
                                    name: 'Goal',
                                    id: eventDetails?.typeOfEventTypeSelected?.name === "Penalty Corner" ? 18 : 19,
                                    backgroundColor: eventDetails?.sideSelected.teamColor, color: '#000'}
                            }
                        });
                        confirmCallback && confirmCallback();
                    }}
                >Goal</button>
                <button
                    style={{backgroundColor: 'rgb(255, 0, 20)', color: '#fff'}}
                    onClick={() => {
                    
                    setEventDetails((data) => {
                        const newEventDetails = {
                            ...data, 
                            typeOfGoal: {
                                name: 'Miss',
                                id: eventDetails?.typeOfEventTypeSelected?.name === "Penalty Corner" ? 28 : 16,
                                backgroundColor: 'rgb(255, 0, 20)', color: '#fff'
                            }
                        }

                        if (pcEventActive) {
                            newEventDetails.typeOfCornerGoalSelected = true;
                            newEventDetails.typeOfPsGoalSelected = {
                                name: 'Miss'
                            }
                        }

                        if (psEventActive) {
                            newEventDetails.typeOfPsGoalSelected = {
                                name: 'Miss'
                            }
                        }
                        return newEventDetails;
                    });
                    confirmCallback && confirmCallback();
                }}>Miss</button>
            </div>
        )}
    </>
    );
};

export default PsPcButtons;
